(function($) {

    var form = $("#signup-form");
    form.validate({
        errorPlacement: function errorPlacement(error, element) {
            console.log(error)
            if (element.attr("type") === "radio") {
                element.parent().parent().after(error);
            }else {
                element.after(error);
            }

        },
        rules: {
            first_name : {
                required: true,
            },
            last_name : {
                required: true,
            },
            email : {
                required: true,
                email: true,
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            },
            email_confirm : {
                equalTo: "#email"
            },
            phone: {
                required: true,      // field is mandatory
                isValidWhatsapp: true  // must contain a valid phone number
            },
            nationality: {
                required: true,
            },
            current_country : {
                required: true,
            },
            nomada_country: {
                required: true,
            },
            nomada_when: {
                required: true,
            },
            nomada_with: {
                required: true,
            },
            contact_when: {
                required: true
            },
            contact_way:{
                required: true
            },
            contact_details:{
                required: true
            },
        },
        messages: {
            email: {
                pattern: 'Email must contain a valid domain (e.g., example@domain.com).'
            }
        },
        onfocusout: function(element) {
            $(element).valid();
        },
       /* highlight : function(element, errorClass, validClass) {
           // console.log(element)
            $(element.form).find('.actions').addClass('form-error');
            $(element).removeClass('valid');
            $(element).addClass('error');
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element.form).find('.actions').removeClass('form-error');
            $(element).removeClass('error');
            $(element).addClass('valid');
        }*/
    });
    form.steps({
        headerTag: "h3",
        bodyTag: "fieldset",
        transitionEffect: "fade",
        labels: {
            previous : previous,
            next : next,
            finish : finish,
            current : ''
        },
        titleTemplate : '<span class="title">#title#</span>',
        onStepChanging: function (event, currentIndex, newIndex)
        {

            //Allways allow user to move backwards.

            if (currentIndex > newIndex) {
                return true;
            }else {
                try {
                    parent.postMessage('formNext', '*');
                } catch(e) {
                    // Something went wrong...
                    window.console && window.console.log(e);
                }
            }
            form.validate().settings.ignore = ":disabled,:hidden";
            return form.valid();

        },
        onFinishing: function (event, currentIndex)
        {
            form.validate().settings.ignore = ":disabled";
           // $('finish').attr('disabled','disabled');
            return form.valid();
        },
        onFinished: function (event, currentIndex)
        {
           // console.log(event);
           // console.log(currentIndex)
            var send_button = $('a[href="#finish"]');
            var language = $('input[name=language]').val();
            send_button.parent().addClass('isDisabled')
            var form = $('#signup-form');
            $.ajax({
                url: form.attr('action'),
                data: form.serialize(),
                type: 'POST',
                success: function(result) {
                    try {
                        if(language === 'es'){
                            parent.postMessage('formSend', '*');
                        }
                    } catch(e) {
                        // Something went wrong...
                        window.console && window.console.log(e);
                    }

                    try {
                        if(language === 'ja'){
                            parent.postMessage('formSendYahoo', '*')
                        }
                    }catch(e) {
                        // Something went wrong...
                        window.console && window.console.log(e);
                    }

                    form.hide();
                    $('.success').show();
                },
                error: function(result) {

                }
            });

            //alert('Sumited');
        },
        // onInit : function (event, currentIndex) {
        //     event.append('demo');
        // }
    });

    jQuery.extend(jQuery.validator.messages, {
        required: required,
        email: invalid_email,
        equalTo: confirm_email
    });

    $.dobPicker({
        daySelector: '#birth_date',
        monthSelector: '#birth_month',
        yearSelector: '#birth_year',
        dayDefault: 'Day',
        monthDefault: 'Month',
        yearDefault: 'Year',
        minimumAge: 0,
        maximumAge: 120
    });

    $.dobPicker({
        daySelector: '#expiry_date',
        monthSelector: '#expiry_month',
        yearSelector: '#expiry_year',
        dayDefault: 'Day',
        monthDefault: 'Month',
        yearDefault: 'Year',
        minimumAge: 0,
        maximumAge: 120
    });
})(jQuery);